var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c("div", { staticClass: "section operations" }, [
        _c(
          "div",
          { staticClass: "triggers" },
          [
            _c(
              "cargo-button-group-slider",
              [
                _c(
                  "div",
                  {
                    staticClass: "input-label",
                    style: _vm.$selectByLang(
                      "width:60px;",
                      "width:60px;",
                      "width:60px;",
                      "width:100px;",
                      "width:100px;",
                      "width:100px;"
                    )
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.FlightNo")))]
                ),
                _c("el-input", {
                  staticStyle: { width: "120px" },
                  model: {
                    value: _vm.filter.flightNo,
                    callback: function($$v) {
                      _vm.$set(_vm.filter, "flightNo", $$v)
                    },
                    expression: "filter.flightNo"
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "input-label",
                    style: {
                      marginLeft: "5px",
                      width: _vm.$selectByLang(
                        "60px",
                        "60px",
                        "60px",
                        "100px",
                        "100px",
                        "100px"
                      )
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.AirlineCompany")))]
                ),
                _c("cargo-advance-select", {
                  staticStyle: { display: "inline-block", width: "200px" },
                  attrs: {
                    "select-type": _vm.TYPE_NAMES.basic_data_Company,
                    "method-params": { airCmp: true },
                    filterable: "",
                    "default-value": _vm.filter.carrierId || ""
                  },
                  on: {
                    parentCallBack: function(p) {
                      _vm.filter.carrierId = p.value || 0
                    }
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "input-label",
                    style: {
                      marginLeft: "5px",
                      width: _vm.$selectByLang(
                        "60px",
                        "60px",
                        "60px",
                        "100px",
                        "100px",
                        "100px"
                      )
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PortOfLoading")))]
                ),
                _c("cargo-advance-select", {
                  staticStyle: { display: "inline-block", width: "120px" },
                  attrs: {
                    "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                    filterable: "",
                    "default-value": _vm.filter.loadingPortCode
                  },
                  on: {
                    parentCallBack: function(p) {
                      _vm.filter.loadingPortCode = p.value
                    }
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "input-label",
                    style: {
                      marginLeft: "5px",
                      width: _vm.$selectByLang(
                        "60px",
                        "60px",
                        "60px",
                        "100px",
                        "100px",
                        "100px"
                      )
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DestinationPort")))]
                ),
                _c("cargo-advance-select", {
                  staticStyle: { display: "inline-block", width: "120px" },
                  attrs: {
                    "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                    filterable: "",
                    "default-value": _vm.filter.destinationPortCode
                  },
                  on: {
                    parentCallBack: function(p) {
                      _vm.filter.destinationPortCode = p.value
                    }
                  }
                }),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.queryHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("SeaExport.Query")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_AirTransitRoutingConfig_add"],
                        expression: "['button_AirTransitRoutingConfig_add']"
                      }
                    ],
                    attrs: { type: "primary" },
                    on: { click: _vm.addFlightHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_AirTransitRoutingConfig_edit"],
                        expression: "['button_AirTransitRoutingConfig_edit']"
                      }
                    ],
                    attrs: { disabled: !_vm.selectedRow, type: "primary" },
                    on: { click: _vm.editFlightHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "permission",
                        rawName: "v-permission",
                        value: ["button_AirTransitRoutingConfig_delete"],
                        expression: "['button_AirTransitRoutingConfig_delete']"
                      }
                    ],
                    attrs: { disabled: !_vm.selectedRow, type: "primary" },
                    on: { click: _vm.delHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "routing-form",
          attrs: {
            visible: _vm.routingDialog.visible,
            title: _vm.routingDialog.title,
            width: _vm.$selectByLang("650px", "690px"),
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.routingDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-width": _vm.$selectByLang("70px", "110px"),
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("SeaExport.Flight") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      value: _vm.routingDialog.flightDescription.flightNo,
                      disabled: true
                    }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.flightDescriptionSelectDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Select")))]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("SeaExport.AirlineCompany") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { display: "inline-block", width: "300px" },
                    attrs: {
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": { airCmp: true },
                      "show-custom-label-in-option": true,
                      "custom-label": _vm.airCompanyLabel,
                      disabled: true,
                      "default-value":
                        _vm.routingDialog.flightDescription.carrierId || "",
                      placeholder: " "
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_PortOfLoading") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      filterable: "",
                      "default-value":
                        _vm.routingDialog.flightDescription.loadingPortCode,
                      placeholder: " "
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_OneWayPort") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      filterable: "",
                      "default-value":
                        _vm.routingDialog.flightDescription.destinationPortCode,
                      placeholder: " "
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_SecondPort") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      filterable: "",
                      "default-value":
                        _vm.routingDialog.form.firstTransshipmentPortCode,
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.routingDialog.form.firstTransshipmentPortCode =
                          p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_ThirdPort") } },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      filterable: "",
                      "default-value":
                        _vm.routingDialog.form.secondTransshipmentPortCode,
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.routingDialog.form.secondTransshipmentPortCode =
                          p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.routingDialog.activeTabName,
                callback: function($$v) {
                  _vm.$set(_vm.routingDialog, "activeTabName", $$v)
                },
                expression: "routingDialog.activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  key: "flightSchedule",
                  attrs: {
                    name: "flightSchedule",
                    label: _vm.$t("CargoMsg.Cargo_FlightSchedule"),
                    lazy: true
                  }
                },
                [
                  _c("div", { staticClass: "section" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "div",
                          {
                            staticClass: "input-label",
                            staticStyle: { color: "blue" }
                          },
                          [_vm._v(_vm._s(_vm.$t("Pricing.BeginDate")))]
                        ),
                        _c("el-date-picker", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            editable: false,
                            clearable: false
                          },
                          model: {
                            value: _vm.routingDialog.form.beginValidDate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routingDialog.form,
                                "beginValidDate",
                                $$v
                              )
                            },
                            expression: "routingDialog.form.beginValidDate"
                          }
                        }),
                        _vm._v(" - "),
                        _c("el-date-picker", {
                          staticStyle: { width: "120px" },
                          attrs: {
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            editable: false,
                            "picker-options": {
                              disabledDate: function(time) {
                                return (
                                  _vm.routingDialog.form.beginValidDate &&
                                  time.getTime() <
                                    new Date(
                                      _vm.routingDialog.form.beginValidDate +
                                        " 00:00:00"
                                    ).getTime()
                                )
                              }
                            }
                          },
                          model: {
                            value: _vm.routingDialog.form.endValidDate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.routingDialog.form,
                                "endValidDate",
                                $$v
                              )
                            },
                            expression: "routingDialog.form.endValidDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-label",
                          style:
                            _vm.$selectByLang("", "width: 100px;") +
                            "align-self: center;color: blue;"
                        },
                        [_vm._v(_vm._s(_vm.$t("AirExport.WeeklySchedule")))]
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "flex-grow": "1",
                            display: "flex",
                            "flex-direction": "column"
                          }
                        },
                        _vm._l(_vm.routingDialog.flightScheduleItem, function(
                          item,
                          index
                        ) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticStyle: {
                                display: "flex",
                                "margin-top": "8px"
                              }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: {
                                    height: "28px",
                                    "line-height": "28px"
                                  },
                                  attrs: { disabled: item.disabled },
                                  model: {
                                    value: item.checked,
                                    callback: function($$v) {
                                      _vm.$set(item, "checked", $$v)
                                    },
                                    expression: "item.checked"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$selectByLang(
                                        _vm.$t("Partners.week"),
                                        ""
                                      )
                                    ) +
                                      _vm._s(_vm.CNWeek[Number(item.itemName)])
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.checked,
                                      expression: "item.checked"
                                    }
                                  ],
                                  staticStyle: {
                                    display: "flex",
                                    "margin-left": "10px"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "blue",
                                        "align-self": "center"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("queryJob.takeoffTime"))
                                      )
                                    ]
                                  ),
                                  _c("el-input-number", {
                                    staticStyle: {
                                      width: "60px",
                                      "margin-left": "5px"
                                    },
                                    attrs: {
                                      disabled: true,
                                      "controls-position": "right",
                                      min: 0,
                                      max: 23,
                                      precision: 0
                                    },
                                    model: {
                                      value: item.departureTimeHour,
                                      callback: function($$v) {
                                        _vm.$set(item, "departureTimeHour", $$v)
                                      },
                                      expression: "item.departureTimeHour"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        margin: "0 5px",
                                        "align-self": "center"
                                      }
                                    },
                                    [_vm._v(":")]
                                  ),
                                  _c("el-input-number", {
                                    staticStyle: { width: "60px" },
                                    attrs: {
                                      disabled: true,
                                      "controls-position": "right",
                                      min: 0,
                                      max: 59,
                                      precision: 0
                                    },
                                    model: {
                                      value: item.departureTimeMinutes,
                                      callback: function($$v) {
                                        _vm.$set(
                                          item,
                                          "departureTimeMinutes",
                                          $$v
                                        )
                                      },
                                      expression: "item.departureTimeMinutes"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-left": "10px",
                                        "align-self": "center"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_ArrivaledTime")
                                        )
                                      )
                                    ]
                                  ),
                                  _c("el-input-number", {
                                    staticStyle: {
                                      width: "60px",
                                      "margin-left": "5px"
                                    },
                                    attrs: {
                                      "controls-position": "right",
                                      min: 0,
                                      max: 23,
                                      precision: 0
                                    },
                                    model: {
                                      value: item.arrivalTimeHour,
                                      callback: function($$v) {
                                        _vm.$set(item, "arrivalTimeHour", $$v)
                                      },
                                      expression: "item.arrivalTimeHour"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        margin: "0 5px",
                                        "align-self": "center"
                                      }
                                    },
                                    [_vm._v(":")]
                                  ),
                                  _c("el-input-number", {
                                    staticStyle: { width: "60px" },
                                    attrs: {
                                      "controls-position": "right",
                                      min: 0,
                                      max: 59,
                                      precision: 0
                                    },
                                    model: {
                                      value: item.arrivalTimeMinutes,
                                      callback: function($$v) {
                                        _vm.$set(
                                          item,
                                          "arrivalTimeMinutes",
                                          $$v
                                        )
                                      },
                                      expression: "item.arrivalTimeMinutes"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "margin-left": "10px",
                                        "align-self": "center"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("Message.Page")))]
                                  ),
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: {
                                        width: "50px",
                                        margin: "0 5px"
                                      },
                                      model: {
                                        value: item.flyingDays,
                                        callback: function($$v) {
                                          _vm.$set(item, "flyingDays", $$v)
                                        },
                                        expression: "item.flyingDays"
                                      }
                                    },
                                    _vm._l(_vm.FLYING_DAYS, function(
                                      item,
                                      index
                                    ) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: { label: item, value: item }
                                      })
                                    }),
                                    1
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "align-self": "center" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Days"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ]
              ),
              _c(
                "el-tab-pane",
                {
                  key: "interiorPoints",
                  attrs: {
                    name: "interiorPoints",
                    label: _vm.$t("CargoMsg.Cargo_TransshipmentPort"),
                    lazy: true
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "section",
                      staticStyle: { height: "290px" }
                    },
                    [
                      _c("cargo-ag-grid", {
                        attrs: {
                          "grid-options": _vm.routingDialog.gridOptions,
                          "column-defs": _vm.routingDialog.columnDefs,
                          "row-data": _vm.routingDialog.airInteriorPoints
                        },
                        on: {
                          gridReady: function(params) {
                            _vm.routingDialog.gridApi = params.api
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticStyle: { display: "flex" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.routingDialog.activeTabName === "interiorPoints",
                      expression:
                        "routingDialog.activeTabName==='interiorPoints'"
                    }
                  ]
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.addPointHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.delPointHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                  )
                ],
                1
              ),
              _c("div", { staticStyle: { "flex-grow": "1" } }),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.commitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.routingDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("flight-description-select-dialog", {
        attrs: { visible: _vm.flightDescriptionSelectDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(
              _vm.flightDescriptionSelectDialog,
              "visible",
              $event
            )
          },
          callback: _vm.selectFlightDescription
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }